import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '../../../../imports'

class CheckboxSetting extends Component {
    update = (newValue) => {
        // If the value is unchanged, don't update
        if (newValue === this.props.value) {
            return
        }

        this.props.update(newValue)
    }

    render() {
        return (
            <Tooltip content={this.props.title}>
                <label htmlFor={this.props.id}>
                    <input
                        type="checkbox"
                        id={this.props.id}
                        name={this.props.name}
                        onChange={event => this.update(event.target.checked)}
                        checked={this.props.value || false}
                    />
                    <span className={this.props.className} />
                    {this.props.label}
                </label>
            </Tooltip>
        )
    }
}

CheckboxSetting.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.bool,
    update: PropTypes.func,
}

CheckboxSetting.defaultProps = {
    title: undefined,
}

export default CheckboxSetting



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/CheckboxSetting/index.js